module.exports = __webpack_public_path__ + "static/media/somewhat_agree.3757cda8.png";